import { t } from 'i18next'

import { formatMoneyV2 } from '~/helpers'

import styles from '../styles.module.css'

interface MarketplaceBalanceProps {
  initialLoading: boolean
  loadingBalance: boolean
  hasMarketplace: boolean
  marketplaceBalance: { total: string } | null
}

export const MarketplaceBalance = ({
  initialLoading,
  loadingBalance,
  hasMarketplace,
  marketplaceBalance
}: Readonly<MarketplaceBalanceProps>) => {
  if (initialLoading || loadingBalance) {
    return (
      <span className={styles.marketplace}>{t('common:actions.loading')}</span>
    )
  }

  if (hasMarketplace && marketplaceBalance?.total != null) {
    return (
      <span className={styles.marketplace}>
        {t('rm:marketplace.title')}:{' '}
        <span className={styles.marketplaceStrong}>
          {formatMoneyV2({ value: marketplaceBalance.total })}
        </span>{' '}
        {t('rm:marketplace.avaiable')}
      </span>
    )
  }

  return null
}
